module.exports = __webpack_public_path__ + "img/switcherstu1.8ceb4582.jpeg";